import lowerFloor from "./plan-2np-3d.jpg.asset.json";
import upperFloor from "./plan-3np-3d.jpg.asset.json";

const photoModules = import.meta.glob("./img-*.jpg.asset.json", {
  eager: true,
  import: "default",
}) as Record<string, { url: string }>;

// Pořadí fotografií odpovídá galerii v inzerátu RE/MAX (zakázka 449884)
const remaxOrder = [
  "img-03",
  "img-07",
  "img-02",
  "img-04",
  "img-06",
  "img-09",
  "img-05",
  "img-08",
  "img-10",
  "img-11",
  "img-12",
  "img-14",
  "img-13",
  "img-15",
  "img-01",
  "img-17",
  "img-18",
  "img-19",
  "img-20",
  "img-16",
];

export const mnichoviceMezonetImages = remaxOrder.map(
  (name) => photoModules[`./${name}.jpg.asset.json`].url,
);

export const mnichoviceMezonetFloorPlans = [
  { image: lowerFloor.url, label: "2. NP – 3D" },
  { image: upperFloor.url, label: "3. NP – 3D" },
];
